import { render, staticRenderFns } from "./CustomerInformationContainer.vue?vue&type=template&id=1fd960c8"
import script from "@/scripts/auth/customerInformationContainer.js?vue&type=script&lang=js&external"
export * from "@/scripts/auth/customerInformationContainer.js?vue&type=script&lang=js&external"
import style0 from "./CustomerInformationContainer.vue?vue&type=style&index=0&id=1fd960c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports